import trusted1 from "@/assets/trusted/coach-1.jpg";
import trusted2 from "@/assets/trusted/coach-2.jpg";
import trusted3 from "@/assets/trusted/coach-3.jpg";
import trusted4 from "@/assets/trusted/coach-4.jpg";
import trusted5 from "@/assets/trusted/coach-5.jpg";
import trusted6 from "@/assets/trusted/coach-6.jpg";
import trusted7 from "@/assets/trusted/coach-7.jpg";
import trusted8 from "@/assets/trusted/coach-8.jpg";
import trusted9 from "@/assets/trusted/coach-9.jpg";
import trusted10 from "@/assets/trusted/coach-10.jpg";
import trusted11 from "@/assets/trusted/coach-11.jpg";
import trusted12 from "@/assets/trusted/coach-12.jpg";
import trusted13 from "@/assets/trusted/coach-13.webp";
import trusted14 from "@/assets/trusted/coach-14.webp";
import trusted15 from "@/assets/trusted/coach-15.png";

// Different order than the About page (which uses sequential 1..15)
const images = [
  trusted7, trusted2, trusted11, trusted5, trusted14, trusted9, trusted1, trusted13,
  trusted4, trusted15, trusted8, trusted3, trusted12, trusted6, trusted10,
];

export function TrustedMarquee() {
  return (
    <section className="relative py-12 md:py-16 overflow-hidden">
      <div className="text-center px-6">
        <h3 className="text-xl md:text-2xl font-bold text-foreground">
          Trusted By <span className="text-primary">100's</span> of Coaches{" "}
          <span className="text-primary">+</span> Experts
        </h3>
      </div>
      <div className="mt-8 relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex gap-6 w-max animate-[marquee_40s_linear_infinite]">
          {[...images, ...images].map((src, idx) => (
            <div
              key={idx}
              className="h-28 w-24 md:h-32 md:w-28 shrink-0 rounded-2xl overflow-hidden bg-muted border border-border"
              aria-hidden="true"
            >
              <img src={src} alt="" width={112} height={128} loading="lazy" decoding="async" className="h-full w-full object-cover object-top" />
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 px-6 flex justify-center md:hidden">
        <a
          href="/book"
          className="inline-flex items-center justify-center rounded-full bg-primary-gradient text-primary-foreground font-semibold h-12 px-6 shadow-glow"
        >
          Get Started With A Free Call
        </a>
      </div>
    </section>
  );
}
